import React from "react";
import HeroV3 from "@/components/Common/HeroV3";
import HowItWorksVariant from "@/components/Common/HowItWorksVariant";
import { SliceZone } from "@prismicio/react";
import AboutMBVariant from "@/components/Common/AboutMBVariant";
import Richtext from "@/components/Common/Richtext/Richtext";
import FeaturesCarousel from "@/components/SellRollex/FeaturesCards/FeaturesCards";
import BrandWeBuy from "@/components/LuxuryWatches/BrandWeBuy";

const SingleSubPage = ({
  pageData,
  components,
  common,
  showBrandWeBuy = true,
}) => {
  const commonData = common?.data;
  return (
    <>
      <HeroV3
        title={pageData?.hero_title}
        description={pageData?.hero_description}
        viewMore={true}
        backgroundImage={pageData?.hero_background_image}
        backgroundImageAlt={pageData?.hero_background_image.alt}
        page={"Bridge Loans"}
      />
      {(commonData?.brandwebuy_title ||
        brandwebuy_title?.brandwebuy_description?.length > 0) &&
        showBrandWeBuy && (
          <BrandWeBuy
            title={commonData?.brandwebuy_title || []}
            description={commonData?.brandwebuy_description || []}
            brandTitle={commonData?.brand_we_buy_tab_title || []}
            brandTabWatch={commonData?.brand_we_buy_tab_watch || {}}
          />
        )}
      {pageData?.text_section_description?.length > 0 && (
        <Richtext
          title={pageData.text_section_title}
          description={pageData.text_section_description}
          data={pageData}
        />
      )}
      {pageData?.feature_section_title?.length > 0 && (
        <FeaturesCarousel data={pageData} />
      )}
      {pageData?.how_it_works_title?.length > 0 && (
        <HowItWorksVariant data={pageData} tableData={commonData?.table} />
      )}
      {pageData?.about_mb_description?.length > 0 && (
        <AboutMBVariant
          data={pageData}
          page="Bag Buyers"
          buttonsDisabled={true}
        />
      )}
      {pageData?.slices3?.length > 0 && (
        <SliceZone
          slices={pageData?.slices3}
          components={components}
          context={{ faqWhiteBg: pageData?.faq_white_bg }}
        />
      )}
    </>
  );
};

export default SingleSubPage;
